import axios, { AxiosPromise } from "axios";

import { AsyncUploadModel } from "models/ApiModels";
import Session from "services/Session";
import { AspectRatio } from "models/ApiEnums";
import { convertBase64lToBlob, convertBlobUrlToBase64 } from "lib/ImageResizer";

export interface FileUploadResult {
    sourceDataOrUrl: string;
    name: string;
    contentType: string;
}


export interface AsyncUploaderProps {
    onFileStarted?: () => void;
    onFileFinished?: () => void;
    onFileUploadSuccess?: (data: AsyncUploadModel) => void;
    onFileUploadError?: (data: any) => void;
    onFileUploadProgress?: (progress: number) => void;
}

export class AsyncUploader {

    private props: AsyncUploaderProps;

    private cancelToken: any;

    constructor(props: AsyncUploaderProps) {
        this.props = props;
    }

    private getAxiosHeaders() {
        const headers: { [key: string]: string } = {};
        headers["Accept"] = "application/json";
        headers["Content-Type"] = "multipart/form-data";
        if (Session.bearerAuthorization != null) headers["Authorization"] = Session.bearerAuthorization;
        return headers;
    }

    //
    private callServer(url: string, formData: FormData): AxiosPromise<AsyncUploadModel> {

        return axios.post<AsyncUploadModel>(url, formData, {
            headers: this.getAxiosHeaders(),
            cancelToken: new axios.CancelToken((c) => {
                // An executor function receives a cancel function as a parameter
                this.cancelToken = c;
            }),
            onUploadProgress: (progressEvent) => {
                if (this.props.onFileUploadProgress) {
                    this.props.onFileUploadProgress((Math.ceil(progressEvent.loaded / progressEvent.total * 100)))
                }
            }
        });
    }

    //
    public delete(ids: string[]): AxiosPromise {
        const formData = new FormData()
        formData.append('filesToRemove', ids.join(","))

        return axios.post("/api/v1.0/AsyncUpload/Remove", formData, {
            headers: this.getAxiosHeaders(),
        });
    }

    //
    public cancel(message: string) {
        this.cancelToken(message);
    }

    //
    public isCancel(thrown: any): boolean {
        return axios.isCancel(thrown) || thrown?.canceled === true;
    }

    public uploadForm(formData: FormData) {

        // Envia para o arquivo.
        if (this.props.onFileStarted)
            this.props.onFileStarted();

        this.callServer("/api/v1.0/AsyncUpload/Save", formData)
            .then((response) => {

                if (this.props.onFileUploadSuccess)
                    this.props.onFileUploadSuccess(response.data);

                if (this.props.onFileFinished)
                    this.props.onFileFinished();
            })
            .catch((error: any) => {
                if (this.props.onFileUploadError)
                    this.props.onFileUploadError(error);

                if (this.props.onFileFinished)
                    this.props.onFileFinished();
            });
    }

    //
    public uploadImage(file: FileUploadResult, autoCreateThumbWithAspectRatio: AspectRatio = null): void {

        new Promise<FormData>((resolve) => {
            // Obtem os dados para envio.
            const formData = new FormData()

            if (file.sourceDataOrUrl.indexOf("http") == 0) {
                formData.append('srcUrl', file.sourceDataOrUrl);
                formData.append('srcName', file.name);
                resolve(formData);
            }
            else if (file.sourceDataOrUrl.indexOf("blob") == 0) {
                convertBlobUrlToBase64(file.sourceDataOrUrl).then((data) => {
                    formData.append('file', convertBase64lToBlob(data, file.contentType), file.name)
                    resolve(formData);
                });
            }
            else {
                formData.append('file', convertBase64lToBlob(file.sourceDataOrUrl, file.contentType), file.name)
                resolve(formData);
            }
        })
            .then((formData) => {
                if (autoCreateThumbWithAspectRatio) {
                    formData.append("createThumbnailAspectRatio", AspectRatio[autoCreateThumbWithAspectRatio])
                }
                this.uploadForm(formData);
            })
            .catch((error) => {
                if (this.props.onFileUploadError)
                    this.props.onFileUploadError(error);
            });
    }
}

